
export const createBuffer = (gl: WebGLRenderingContext, data: ArrayBufferView): WebGLBuffer => {
    const buffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
    gl.bufferData(gl.ARRAY_BUFFER, data, gl.STATIC_DRAW);
    // @ts-ignore
    return buffer! as WebGLBuffer;
};